// 菜单，侧边栏
import home from './modules/home';    // 首页
// import alliance from './modules/alliance';    // 联盟管理
import chainmaker from './modules/chainmaker';    // 区块链管理
import FiscoBcos from './modules/fisco-bcos';  // fisco
import setting from './modules/setting';  // 个人中心
import basic from './modules/basic';  // 个人中心
import super1 from './modules/super';  // 超级管理员
import carbon from './modules/carbon';  // 碳行中国
// 财务报表
import report from "./modules/report"


export default [
	home,
	// alliance,
	chainmaker,
	carbon,
	report,  // 财务报表
	FiscoBcos,
	super1,
	setting,
	basic,


];
